import React, { forwardRef } from 'react';
import { cn } from './Button';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  containerClass?: string;
  background?: 'cream' | 'white' | 'celeste';
}
export const Section = forwardRef<HTMLElement, SectionProps>(({
  className,
  containerClass,
  background = 'cream',
  children,
  ...props
}, ref) => {
  return <section ref={ref} className={cn('py-16 md:py-24', {
    'bg-cream-50': background === 'cream',
    'bg-white': background === 'white',
    'bg-celeste-50': background === 'celeste'
  }, className)} {...props} data-id="element-381">
        <div className={cn('mx-auto max-w-6xl px-4 sm:px-6 lg:px-8', containerClass)} data-id="element-382">
          {children}
        </div>
      </section>;
});
Section.displayName = 'Section';